// extracted by mini-css-extract-plugin
export default {"recos":"T3-z","productCardOverride":"U3-z","rowHasBadge":"V3-z"};